// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteDialog_deleteButton__Ti61q","cancelButton":"DeleteDialog_cancelButton__XWsu8"};